import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";
import { API_GET_EMPLOYEE_FILE } from "../../../config/Endpoints";
import img from "../../../Styles/images/profile3.png";

const EmployeeCard = ({ employee }) => {
  const navigate = useNavigate();
  const [profileImage, setProfileImage] = useState(img);
  const accessToken = Cookies.get("accessToken");
  const handleProfile = (e) => {
    e.preventDefault();
    navigate("/dashboard/biometric-employee-profile", {
      state: {
        data: employee?.id,
      },
    });
  };

  useEffect(() => {
    const fetchImage = async () => {
      if (employee?.photoPath) {
        const parts = employee.photoPath.split("/");
        const result = parts.slice(3).join("/");

        try {
          const res = await axios.get(API_GET_EMPLOYEE_FILE, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
            params: { filepath: result },
            responseType: "blob",
          });

          if (res.status === 200) {
            const imageUrl = URL.createObjectURL(res.data);
            console.log(imageUrl);
            setProfileImage(imageUrl);
          }
        } catch (err) {
          console.error("Error fetching image:", err);
        }
      }
    };

    fetchImage();
  }, [employee?.photoPath, accessToken]);

  return (
    <div
      className="card"
      style={{ position: "relative" }}
      onClick={handleProfile}
    >
      <div className="user-type-tag">
        <span
          className={`badge bg-${
            employee.employeeType === "REGULAR" ? "success" : "primary"
          }`}
        >
          {employee.employeeType}
        </span>
      </div>

      <img
        src={profileImage}
        className="round-profile m-auto"
        width={180}
        height={180}
        alt={employee.firstName}
      />

      <div className="card-body text-center px-0">
        <h6 className="card-title text-primary">{employee.empName}</h6>
        <h6 className="card-text">
          <small>{employee.designation}</small>
        </h6>
        <small className="card-text">{employee.department}</small>
      </div>
    </div>
  );
};

export default EmployeeCard;
